import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import BranchMiddleware from "../../../../middleware/modules/master/branch";
import Form from "../../../../components/modules/master/branch/form";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import CityMiddleware from "../../../../middleware/modules/master/city";

const mapStateToProps = ({ auth, branch, city }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: branch.isProcessing,
  isError: branch.isError,
  errorMessage: branch.errorMessage,
  dataUpdate: branch.single,
  isSuccess: branch.isSuccess,
  isReset: branch.isReset,
  isNewRecord: branch.isNewRecord,
  onSubmit: branch.onSubmit,
  cityList: city.helperCity,
  helperBranch:branch.helperBranch,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeModal: () => BranchMiddleware.reset(),
      getCity: (id) => CityMiddleware.getHelper(id),
      new: (data, search) => BranchMiddleware.beforeSaveNew(data, search),
      update: (id, type, search) =>
        BranchMiddleware.beforeSaveUpdate(id, type, search),
    },
    dispatch
  );
};
class FormContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      longitude:'',
      map:0,
      geo:[],
      latitude:'',
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.getData = this.getData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.close = this.close.bind(this);
    this.changeSelect = this.changeSelect.bind(this);
    this.getGeo = this.getGeo.bind(this);
  }

  getData() {
    return this.props.showOne(this.props.dataID);
  }

  close() {
    this.props.closeModal();
  }
  submitForm() {
    const { search, isNewRecord, dataUpdate } = this.props;
    var form = this.form.current.runSubmit();
    if (isNewRecord) {
      this.props.new(form, search);
    } else {
      this.props.update(dataUpdate.id, form, search);
    }
  }

  changeSelect(type, value = null) {
    const params = { id: value };
    switch (type) {
      case "idProvince":
        this.props.getCity(params);
        break;
      default:
        break;
    }
  }
  
  getGeo(){
    let geo = [];
    
    return geo
  }

  render() {
    if(this.state.map == 0){
      
    navigator.geolocation.getCurrentPosition((position)=> {
        this.state.geo.push({longitude:position.coords.longitude,latitude:position.coords.latitude})
    },
    error => console.log(error),
    {
      enableHighAccuracy: false,
      timeout: 20000,
      maximumAge: 10,
      distanceFilter: 0,
    },
    
    );
    this.state.map = 1;

  } 
    const {
      isNewRecord,
      onSubmit,
      showModal,
      titleModal,
      isReset,
      dataUpdate,
      cityList,
      isProcessing,
      isError,
      errorMessage,
      helperBranch,
    } = this.props;
    return (
      <>
        <Modal show={showModal} size={"lg"}>
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
            <title>{titleModal}</title>
          </Helmet>
          <Modal.Body>
            <Form
              isNewRecord={isNewRecord}
              isReset={isReset}
              data={dataUpdate}
              isProcessing={isProcessing}
              isError={isError}
              cityList={cityList}
              helperBranch={helperBranch}
              errorMessage={errorMessage}
              ref={this.form}
              changeSelect={this.changeSelect}
              getGeo={this.state.geo}
            />
          </Modal.Body>
          <Modal.Footer className={(!onSubmit)?"justify-content-between":"justify-content-center"}>
            {onSubmit ? (
              ""
            ) : (
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            )}
            <Button variant="primary" onClick={() => ((onSubmit)?false:this.submitForm(true))}>
              {onSubmit ? (
                <span className="indicator-progress show">
                  {i18n.t("Please wait...")}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="indicator-label">{i18n.t("Save")}</span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
